import { InjectionToken } from '@angular/core';

export interface SentryEnvironmentToken {
  isProduction: boolean;
  isLocal: boolean;
}

export const SENTRY_ENVIRONMENT = new InjectionToken<SentryEnvironmentToken>('SentryEnvironment');
